import React, { Suspense } from "react";
import type { ISbStoryData } from "@storyblok/react/rsc";
import { fetchContentType } from "@/lib/storyblok_utils";
import CarouselClient, { CarouselSkeleton } from "./CarouselClient";
import { CarouselStoryblok } from "@/component-types-sb";

// The stories are fetched here on the server, like EventGrid and GenericGrid.
// Until 2026-10 the browser fetched them from Storyblok itself, which put the
// preview token (it reads drafts) into every visitor's JavaScript.
interface CarouselProps {
  blok: CarouselStoryblok;
  data?: {
    version?: "draft" | "published";
  };
}

const CarouselAsync = async ({
  blok,
  version,
}: {
  blok: CarouselStoryblok;
  version: "draft" | "published";
}) => {
  let stories: ISbStoryData[] = [];
  let error: string | undefined;

  try {
    ({ stories } = await fetchContentType(
      `${blok.type}/`,
      version,
      Number(blok.count_items) || 3
    ));
  } catch (cause) {
    error = cause instanceof Error ? cause.message : "Unknown error";
  }

  return <CarouselClient blok={blok} stories={stories} error={error} />;
};

const Carousel: React.FC<CarouselProps> = ({ blok, data }) => {
  const version = data?.version ?? "published";

  return (
    <Suspense fallback={<CarouselSkeleton blok={blok} />}>
      <CarouselAsync blok={blok} version={version} />
    </Suspense>
  );
};

export default Carousel;
